import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * État synchronisé avec l'URL (?key=value). Chaque changement crée une entrée d'historique :
 * le bouton retour (navigateur, geste mobile, bouton de l'appli) revient à l'onglet / filtre / détail précédent.
 */
export function useUrlParam(key, defaultValue = '', { replace = false } = {}) {
  const [params, setParams] = useSearchParams();
  const value = params.get(key) ?? defaultValue;
  const setValue = useCallback((next, opts = {}) => {
    const sp = new URLSearchParams(window.location.search);
    const v = typeof next === 'function' ? next(sp.get(key) ?? defaultValue) : next;
    if (v === null || v === undefined || v === '' || v === defaultValue) sp.delete(key); else sp.set(key, String(v));
    if (sp.toString() === new URLSearchParams(window.location.search).toString()) return;
    setParams(sp, { replace: opts.replace ?? replace });
  }, [key, defaultValue, replace, setParams]);
  return [value, setValue];
}

export function useUrlParams() {
  const [params, setParams] = useSearchParams();
  const patch = useCallback((obj, { replace = false } = {}) => {
    const sp = new URLSearchParams(window.location.search);
    Object.entries(obj).forEach(([k, v]) => { if (v === null || v === undefined || v === '') sp.delete(k); else sp.set(k, String(v)); });
    setParams(sp, { replace });
  }, [setParams]);
  return [params, patch];
}

// Ordre hiérarchique des paramètres : le dernier présent est le niveau le plus profond
export const PARAM_LEVELS = ['tab', 'subtab', 'mode', 'view', 'doc', 'edit', 'mandat', 'id', 'employee', 'detail'];
export const PARAM_LABELS = { tab: '', subtab: '', mode: '', view: '', doc: 'Document', edit: 'Édition', mandat: 'Mandat', id: 'Détail', employee: 'Salarié', detail: 'Détail' };
